"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbagcheck = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 52 54",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbagcheck` : '') + (description ? ` desc-brandedbagcheck` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbagcheck"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbagcheck"
  }, description), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_15832_7887",
    style: {
      "maskType": "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "45",
    height: "52"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.37 1.77A2 2 0 0 1 8.35 0h28.4a2 2 0 0 1 1.99 1.75l5.98 48A2 2 0 0 1 42.74 52H2.43a2 2 0 0 1-1.97-2.38l.8-4.12 5.1-43.73Z",
    fill: "#F8985A"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_15832_7887)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.37 1.77A2 2 0 0 1 8.35 0h28.4a2 2 0 0 1 1.99 1.75l5.98 48A2 2 0 0 1 42.74 52H2.43a2 2 0 0 1-1.97-2.38l.8-4.12 5.1-43.73Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m44.5 51 .14-.31c.1-.27.1-.81.1-.92l-5-40.07C28.6 22.97 16.88 32.26 1.78 41.05L.43 50.3A2 2 0 0 0 2.3 52l20.83-.04 19.73.06c.13-.02.4-.06.67-.18.23-.1.44-.24.61-.41l.07-.07a4 4 0 0 0 .22-.26c.06-.07.02-.02.06-.1Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "13.66",
    y: "4.52",
    width: "18.2022",
    height: "3.3913",
    rx: "1.69565",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "40",
    cy: "42",
    r: "12",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.93 31a11 11 0 1 0 .14 22 11 11 0 0 0-.14-22ZM38.7 47.36h-.19a2.6 2.6 0 0 1-1.8-.74l-2.53-2.54a1.27 1.27 0 0 1 .4-2.07 1.25 1.25 0 0 1 1.4.28l2.2 2.25a.44.44 0 0 0 .33.13.5.5 0 0 0 .3-.17l4.63-6.17a1.29 1.29 0 0 1 1.69-.26 1.27 1.27 0 0 1 .25 1.7l-4.9 6.56a2.5 2.5 0 0 1-1.78 1.03Z",
    fill: "#1ECAD3"
  }));
};
var _default = exports.default = brandedbagcheck;